<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader class="p-1" >
                        <CRow>
                            <CCol col="4" style="text-align: start ;padding:10px 20px 0 20px ">
                                <strong v-if="status_form==0">{{ $t('components.addUser') }}</strong>
                                <strong v-if="status_form!=0">{{ $t('components.editUser') }} </strong>

                            </CCol>
                            <CCol col="4" style="text-align: center ;padding:10px 20px 0 20px ">
                                <strong v-if="status_form!=0">{{edit_user_code}} {{edit_name}} {{edit_last_name}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">
                                <CButton v-if="status_form==0" class="mr-1" @click="insert_data()" type="submit" size="sm"
                                         color="secondary">
                                    {{ $t('buttons.save') }}
                                </CButton>
                                <CButton v-if="status_form!=0"  class="mr-1" @click="insert_data()" type="submit" size="sm"
                                         color="secondary">
                                    {{ $t('buttons.edit') }}
                                </CButton>
                                <!--                <CButton-->
                                <!--                    class="mr-1"-->
                                <!--                    size="sm"-->
                                <!--                    color="secondary"-->
                                <!--                >{{ $t("buttons.cancel") }}-->
                                <!--                </CButton>-->
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        color="secondary"
                                >{{ $t("buttons.print") }}
                                </CButton>
                                <a href="/dashboard/users/add-user" target="_blank">
                                    <CButton
                                            class="mr-1 ml-1"
                                            size="sm"
                                            color="dark"
                                    >
                                        <CIcon size="sm" name="cil-plus"></CIcon>
                                    </CButton>
                                </a>
                            </CCol>
                        </CRow>
                        <!--        </div>-->

                        <!-- Right aligned nav items -->
                        <!--      </CCollapse>-->
                    </CCardHeader>

                    <CCardBody>
                        <BTabs :active-tab.sync="active_tab">
                            <CTab :title="$t('components.userInformation')">
                                <CRow>
                                    <CCol col="4" class="border">
                                        <CCardHeader class="m-1 p-1">
                                            <strong>{{ $t('PersonalInfo') }}</strong>
                                        </CCardHeader>
                                        <!--                    <CSelect-->
                                        <!--                        :label="$t('components.gender')"-->
                                        <!--                        horizontal-->
                                        <!--                        :value.sync="gender"-->

                                        <!--                        :options="gender_options"-->
                                        <!--                    />-->
                                        <CSelect
                                                :label="$t('components.title')"
                                                horizontal
                                                :value.sync="title"
                                                :options="prefx_options"
                                        />
                                        <CInput
                                                :label="$t('components.name')"
                                                horizontal
                                                v-model="name"
                                        />
                                        <CInput
                                                :label="$t('components.middleName')"
                                                horizontal
                                                v-model="middle_name"
                                        />
                                        <CInput
                                                :label="$t('components.surName')"
                                                horizontal
                                                v-model="sur_name"
                                        />

                                        <!--                    <CSelect-->
                                        <!--                        :label="$t('tables.type')"-->
                                        <!--                        :options="person_types"-->
                                        <!--                        horizontal-->
                                        <!--                        :value.sync="person_type"-->
                                        <!--                    />-->


                                    </CCol>
                                    <CCol col="4" class="border">

                                        <CCardHeader class="m-1 p-1">
                                            <strong>{{ $t('components.address') }}</strong>
                                        </CCardHeader>

                                        <CInput v-if="$i18n.locale=='en'"
                                                :label="$t('address')"
                                                :placeholder="$t('languageAddress')"
                                                horizontal
                                                v-model="user_address"
                                        />
                                        <CSelect
                                                :label="$t('components.province')"
                                                :value.sync="selected_province"
                                                horizontal
                                                :options="province_items"
                                        />
                                        <CSelect
                                                :label="$t('components.city')"
                                                :value.sync="selected_city"
                                                horizontal
                                                :options="city_items"
                                        />
                                        <CSelect
                                                :label="$t('town')"
                                                :value.sync="selected_district"
                                                horizontal
                                                :options="district_items"
                                        />
                                        <CSelect
                                                :label="$t('components.area')"
                                                :value.sync="selected_area"
                                                horizontal
                                                :options="area_items"
                                        >
                                            <template #append-content>
                                                <CIcon size="sm" v-on:click.native="go_to_add_modal('add_area')"
                                                       name="cil-plus"/>
                                            </template>
                                        </CSelect>

                                        <CInput v-if="$i18n.locale=='fa'"
                                                :label="$t('address')"
                                                :placeholder="$t('languageAddress')"
                                                horizontal
                                                v-model="user_address"
                                        />
                                        <CInput
                                                :label="$t('PostCode')"
                                                v-model="postCode"
                                                horizontal

                                                placeholder="A-Z 0-9"
                                                @keypress="isPostCode"
                                        >
                                            <template #append-content>
                                                <CIcon v-on:click.native="mapModal = true" class="text-white"
                                                       name="cil-location-pin"/>

                                            </template>
                                        </CInput>
                                        <CImg v-if="user_location_lng != 0 && user_location_lng != null"
                                              :src="'https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/pin-l-embassy+f74e4e('+user_location_lng+','+user_location_lat+')/'+user_location_lng+','+user_location_lat+',14/300x80?access_token=pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg'"/>

                                        <CSelect
                                                :label="$t('Country')"
                                                :value.sync="selected_country"
                                                horizontal
                                                :options="country_items"
                                        />
                                    </CCol>

                                    <CCol col="4" class="border">
                                        <CCardHeader class="m-1 p-1">
                                            <!--                                            <strong>{{$t('Contacts')}}</strong>-->
                                        </CCardHeader>
                                        <div>
                                            <CInputFile

                                                    v-show="false"
                                                    ref="file_selector"
                                                    v-on:change="handleFileUpload"
                                            />
                                            <CRow>
                                                <CButton v-if="file" size="sm"
                                                         @click="clear_input_file,file=null,previewImage='/img/placeholder.png'"
                                                         color="danger">
                                                    <CIcon name="cil-x" buttonClasses="bg-danger close"/>
                                                </CButton>
                                                <CCol col="12" class="text-center" v-on:click="open_file_selector"
                                                >

                                                    <CImg height="120px"
                                                          width="100px"
                                                          v-model="previewImage"
                                                          :src="previewImage"
                                                    />

                                                </CCol>

                                            </CRow>
                                        </div>
                                        <br>
                                        <CRow v-for="phone_obj in email_objects" :key="'A'+phone_obj.row_id">
                                            <CCol col="12">
                                                <CInput
                                                        class="m-0"

                                                        :placeholder="$t('components.email')"
                                                        :value.sync="phone_obj.phone"
                                                >
                                                </CInput>
                                            </CCol>
                                        </CRow>
                                        <br>

                                        <CRow v-if="$i18n.locale=='fa'" v-for="phone_obj in phone_objects"
                                              :key="'B'+phone_obj.row_id">
                                            <CCol col="6" class="pl-0">
                                                <CInput
                                                        class="m-0"
                                                        maxlength="11"
                                                        :placeholder="$t('components.number')"
                                                        :value.sync="phone_obj.phone"
                                                >
                                                    <template #prepend-content>
                                                        <CIcon v-on:click.native="remove_phone_obj(phone_obj.row_id)"
                                                               name="cil-minus"/>

                                                    </template>
                                                </CInput>
                                            </CCol>
                                            <CCol col="6" class="pr-0">

                                                <CSelect
                                                        class="m-0"
                                                        :options="contact_options"

                                                        :value.sync="phone_obj.phone_type"

                                                >


                                                    <template #append-content>
                                                        <CIcon v-on:click.native="add_phone_obj()" name="cil-plus"/>

                                                    </template>
                                                </CSelect>
                                            </CCol>
                                        </CRow>
                                        <CRow v-if="$i18n.locale=='en'" v-for="phone_obj in phone_objects"
                                              :key="'B'+phone_obj.row_id">
                                            <CCol col="6" class="pr-0">
                                                <CInput
                                                        class="m-0"
                                                        maxlength="11"
                                                        :placeholder="$t('components.number')"
                                                        :value.sync="phone_obj.phone"
                                                >
                                                    <template #prepend-content>
                                                        <CIcon v-on:click.native="remove_phone_obj(phone_obj.row_id)"
                                                               name="cil-minus"/>

                                                    </template>
                                                </CInput>
                                            </CCol>
                                            <CCol col="6" class="pl-0">

                                                <CSelect
                                                        class="m-0"
                                                        :options="contact_options"

                                                        :value.sync="phone_obj.phone_type"

                                                >


                                                    <template #append-content>
                                                        <CIcon v-on:click.native="add_phone_obj()" name="cil-plus"/>

                                                    </template>
                                                </CSelect>
                                            </CCol>
                                        </CRow>
                                    </CCol>
                                </CRow>

                                <CDataTable
                                        :items="items_jobs"
                                        :fields="job_fields"
                                        :items-per-page="20"
                                        style="z-index: 1000;margin-bottom: 50px"
                                >
                                    <template #branch="{item,index}">

                                        <td v-if="index!=0">
                                            <p>{{ item.branch }}</p>

                                        </td>
                                        <td v-else>
                                            <CSelect
                                                    :options="branch_items"
                                                    :value.sync="selected_branch"
                                                    horizontal
                                            />

                                        </td>

                                    </template>

                                    <template #department="{item,index}">

                                        <td v-if="index!= 0">
                                            <p>{{ item.department }}</p>

                                        </td>
                                        <td v-else>
                                            <CRow form class="form-group">

                                                <CCol sm="9">
                                                    <CSelect
                                                            :options="department_items"
                                                            :value.sync="selected_department"
                                                            horizontal
                                                    />
                                                </CCol>

                                            </CRow>

                                        </td>

                                    </template>

                                    <template #title="{item,index}">

                                        <td v-if="index != 0">
                                            <p>{{ item.title }}</p>

                                        </td>
                                        <td v-else>
                                            <CSelect
                                                    :options="job_items"
                                                    horizontal
                                                    :value.sync="selected_job"
                                            />
                                        </td>


                                    </template>

                                    <template #default="{item,index}">

                                        <td v-if="index==0">
                                            <!--                      <p>{{ item.default }}</p>-->

                                        </td>
                                        <td v-else>
                                            <CInputRadio
                                                    size="sm"
                                                    @change="jobs_defualt_checked(index)"
                                                    :checked.sync="item.default"
                                                    color="primary">
                                            </CInputRadio>
                                        </td>

                                    </template>
                                    <template #operation="{item,index}">
                                        <td v-if="index==0">
                                            <CButton
                                                    color="dark"
                                                    square
                                                    @click="add_job_item()"
                                                    size="sm"
                                                    :title="$t('buttons.add')"
                                            >
                                                <CIcon size="sm" name="cil-plus"/>
                                            </CButton>

                                        </td>
                                        <td v-else>
                                            <CButton class="m-1"
                                                     color="warning"
                                                     variant="outline"
                                                     square
                                                     @click="job_item_delete(index)"
                                                     size="sm"
                                                     :title="$t('buttons.delete')"
                                            >
                                                <CIcon name="cil-minus"/>
                                            </CButton>
                                            <!--                      <CButton class="m-1"-->
                                            <!--                               color="warning"-->
                                            <!--                               variant="outline"-->
                                            <!--                               square-->
                                            <!--                               @click="job_item_edit(item,index)"-->
                                            <!--                               size="sm"-->
                                            <!--                               :title="$t('buttons.edit')"-->
                                            <!--                      >-->
                                            <!--                        <CIcon name="cil-pencil"/>-->
                                            <!--                      </CButton>-->

                                        </td>
                                    </template>

                                </CDataTable>
                            </CTab>
                            <CTab :title="$t('OtherInfo')">
                                <CRow>
                                    <CCol col="4" class="border">

                                        <CCardHeader class="m-1 p-1">
                                            <strong>{{ $t('OtherInfo') }}</strong>
                                        </CCardHeader>

                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="4" class="col-form-label">
                                                {{ $t('components.birthDate') }}

                                            </CCol>
                                            <CCol sm="8">
                                                <date-picker
                                                        v-model="birth_date"

                                                ></date-picker>
                                            </CCol>

                                        </CRow>

                                        <CInput
                                                :label="$t('components.nino')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                                                v-model="bime_number"
                                        />
                                        <CSelect
                                                :label="$t('components.maritalStatus')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                                                :value.sync="MaritalStatus"

                                                :options="marital_options"
                                        />

                                        <CInput
                                                :label="$t('components.nationality')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                                                :value.sync="nationality"


                                        />
                                        <CSelect
                                                :label="$t('components.residentStatus')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                                                :value.sync="residentStatus"
                                                :options="resident_options"
                                        />

                                        <CInput
                                                :label="$t('components.nationalCode')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                                                v-model="meli_code"
                                        />
                                        <CInput
                                                :label="$t('OtherLanguage')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                                                v-model="emergency_language"

                                        />
                                        <CSelect
                                                :label="$t('Education')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                                                :value.sync="emergency_education"
                                                :options="emergency_educations"
                                        />
                                        <CInput
                                                :label="$t('Skills')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                                                v-model="emergency_skills"

                                        />
                                        <CInput
                                                :label="$t('TrainingCourses')"
                                                :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                                                v-model="emergency_training"

                                        />


                                    </CCol>
                                    <CCol col="4" class="border">

                                        <CRow>
                                            <CCol col="12" class="border">
                                                <CCardHeader class="m-1 p-1">
                                                    <strong>{{ $t('BankInfo') }}</strong>
                                                </CCardHeader>
                                                <CSelect
                                                        :label="$t('components.bank')"
                                                        :options="bank_items"
                                                        :value.sync="selected_bank"
                                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                                />

                                                <CInput
                                                        :label="$t('AccountName')"
                                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                        v-model="account_name"
                                                />
                                                <CInput
                                                        :label="$t('AccountNo')"
                                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                        v-model="account_no"

                                                />
                                                <CInput
                                                        :label="$t('SortCode')"
                                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                        v-model="sort_code"

                                                />
                                                <CInput
                                                        :label="$t('IBAN')"
                                                        :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                        v-model="ibna"

                                                />

                                            </CCol>
                                            <CCol col="12" class="border">
                                                <CCardHeader class="m-1 p-1">
                                                    <strong>{{$t('userStatus')}}</strong>
                                                </CCardHeader>
                                                <CSelect
                                                        :label="$t('components.status')"
                                                        :options="status_items"
                                                        :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                                                        :value.sync="selected_status"

                                                />
                                                <CSelect
                                                        :label="$t('components.userRole')"
                                                        :options="permission_group_items"
                                                        :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                                                        :value.sync="selected_permission_group"
                                                />

                                            </CCol>
                                        </CRow>
                                    </CCol>
                                    <CCol col="4" class="border">

                                        <CCardHeader class="m-1 p-1">
                                            <strong>{{ $t('EmergencyContact') }}</strong>
                                        </CCardHeader>

                                        <CInput
                                                :label="$t('name')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="emergency_name"

                                        />
                                        <CInput
                                                :label="$t('surName')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="emergency_surname"

                                        />
                                        <CSelect
                                                :label="$t('Relationship')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                :value.sync="emergency_relationship"
                                                :options="emergency_relationships"
                                        />
                                        <CInput
                                                :label="$t('mobile')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="emergency_mobile"

                                        />

                                    </CCol>
                                </CRow>


                            </CTab>
                            <CTab :title="$t('JobProfile')">
                                <CRow>
                                    <CCol col="4">

                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="5" class="col-form-label">
                                                {{ $t('EmploymentDate') }}
                                            </CCol>
                                            <CCol sm="7">
                                                <date-picker
                                                        v-model="employee_date"

                                                ></date-picker>
                                            </CCol>
                                        </CRow>

                                        <CInput
                                                :label="$t('ContractNumber')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="contract_number"

                                        />
                                        <CSelect
                                                :label="$t('CooperationType')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                :value.sync="comperation_type"
                                                :options="work_time_options"

                                        />
                                        <hr>
                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="5" class="col-form-label">
                                                {{ $t('LeaversDate') }}
                                            </CCol>
                                            <CCol sm="7">
                                                <date-picker
                                                        v-model="leave_date"

                                                ></date-picker>
                                            </CCol>
                                        </CRow>

                                        <CInput
                                                :label="$t('ReasonsForLeaving')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="reson_for_leave"

                                        />
                                        <!--                    <hr>-->
                                        <CInput
                                                :label="$t('Benefit')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="benefit"

                                        />

                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="5" class="col-form-label">
                                                {{ $t('PensionStartDate') }}
                                            </CCol>
                                            <CCol sm="7">
                                                <date-picker
                                                        v-model="pension_date"

                                                ></date-picker>
                                            </CCol>
                                        </CRow>
                                        <hr>
                                    </CCol>
                                    <CCol col="4">

                                        <CInput
                                                :label="$t('WagePerHour')+' '+this.currency_symbol()"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="wage"
                                                v-on:keypress="isDecimal($event)"

                                        />
                                        <CSelect
                                                :label="$t('Shift')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                :options="shift_options"
                                                :value.sync="shift"

                                        />

                                        <CInput
                                                :label="$t('Hours')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                v-model="hours"

                                        />
                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="5" class="col-form-label">
                                                {{$t('nightJob')}}
                                            </CCol>
                                            <CCol sm="7">
                                                <CInputCheckbox :checked.sync="night_job"/>
                                            </CCol>
                                        </CRow>

                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="5" class="col-form-label">
                                                {{$t('partJob')}}
                                            </CCol>
                                            <CCol sm="7">
                                                <CInputCheckbox :checked.sync="shift_job"/>
                                            </CCol>
                                        </CRow>
                                        <CRow form class="form-group">
                                            <CCol tag="label" sm="5" class="col-form-label">
                                                {{$t('extraJob')}}
                                            </CCol>
                                            <CCol sm="7">
                                                <CInputCheckbox :checked.sync="extra_job"/>
                                            </CCol>
                                        </CRow>
                                        <hr>

                                    </CCol>
                                    <CCol col="4">
                                        <CSelect
                                                :label="$t('payConditions')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                :options="payments_options"
                                                :value.sync="payment_method"

                                        />
                                        <CSelect
                                                :label="$t('PaymentTerms')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                                                :value.sync="payment_frequency"
                                                :options="frequency_options"

                                        />

                                        <CInput
                                                :label="$t('staticComisionPercent')"
                                                :description="$t('components.commissionCoefficientSummary')"
                                                :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                                                type="number"
                                                v-on:keypress="isNumber($event)"
                                                v-model="porsant"
                                        />

                                    </CCol>


                                </CRow>

                            </CTab>
                            <CTab :title="$t('components.accountingReport')" v-if="status_form!=0">

                                <PersonAccountingReport/>
                            </CTab>
                            <CTab :title="$t('VisitorCategory')" v-if="get_access('visitor_category')">
                                <VisitorCategory/>
                            </CTab>

                        </BTabs>


                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CRow>

        </CRow>
        <CModal
                :show.sync="mapModal"
                :no-close-on-backdrop="true"
                color="transparent"
                border-color="primary"
                :title="$t('components.map')"
        >

            <div :style="{ height: '250px'}" id='map'></div>

            <template #footer>
                <CButton
                        @click="mapModal = false"
                        color="danger"
                >{{ $t("buttons.close") }}
                </CButton>
            </template>
        </CModal>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import mapboxgl from 'mapbox-gl'

    import PersonAccountingReport from "./PersonAccountingReport";
    import moment from 'moment-jalaali'
    import Vue from "vue";
    import BTabs from "../../tabs/BTabs";
    import VisitorCategory from "../visitors/VisitorCategory";

    export default {
        name: 'Login',
        components: {
            BTabs,
            Treeselect,
            PersonAccountingReport,
            VisitorCategory,
        },
        data() {
            return {
                active_tab:0,
                edit_name: '',
                edit_last_name: '',
              edit_user_code: '',

                country_items: [],
                selected_country: 0,

                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                map: null,
                postCode: '',
                polygon_area: [
                    [-67.13734351262877, 45.137451890638886],
                    [-66.96466, 44.8097],
                    [-68.03252, 44.3252],
                    [-69.06, 43.98],
                    [-70.11617, 43.68405],

                ],
                job_fields: [
                    {key: 'branch', label: this.$t('tables.branch'), _style: 'width:10%'},
                    {key: 'department', label: this.$t('Department'), _style: 'width:10%'},
                    {key: 'title', label: this.$t('jobTitle'), _style: 'width:10%'},
                    {key: 'default', label: this.$t('Default'), _style: 'width:10%'},
                    {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%'},
                ],
                polygon_area_count: 0,
                mapModal: false,

                polygon_draw: null,
                birth_date: '',
                title: '',
                name: '',
                middle_name: '',
                sur_name: '',
                gender: '',
                nationality: '',
                MaritalStatus: '',
                residentStatus: '',
                bime_number: 0,
                bank_items: [],
                selected_bank: 0,
                account_name: '',
                account_no: 0,
                sort_code: 0,
                ibna: 0,
                emergency_name: '',
                emergency_surname: '',
                emergency_relationships: [],
                emergency_relationship: '',
                emergency_mobile: '',
                emergency_language: '',
                emergency_education: '',
                emergency_educations: [],
                emergency_skills: '',
                emergency_training: '',
                emergency_disability: '',
                employee_date: '',
                contract_number: 0,
                comperation_type: '',
                reson_for_leave: '',
                benefit: '',
                pension_date: '',
                leave_date: '',
                wage: 0,
                shift: '',
                hours: '',
                payment_frequency: '',
                payment_method: '',
                prefx_options: [],
                contact_options: [],
                gender_options: [],
                marital_options: [],
                shift_options: [],
                frequency_options: [],
                payments_options: [],
                resident_options: [],
                work_time_options: [],
                person_types: [],
                person_type: 0,
                show_map_check: false,
                status_items: [],
                selected_status: 0,
                branch_items: [],
                selected_branch: 0,
                selected_job: 0,
                department_items: [],
                selected_department: null,
                department_all_job_titles: [],
                normalizer_department(node) {
                    return {
                        id: node.id,
                        label: node.name,
                        children: node.children,

                    }
                },
                file: '',
                password: '',
                user_location_lat: 0,
                user_location_lng: 0,
                meli_code: '',
                mobile: '',
                phone_no: '',
                tablo_name: '',
                porsant: '0',
                phone_objects: [{phone_type: 19, phone: '', row_id: 1}],
                email_objects: [{phone_type: 18, phone: '', row_id: 1}],
                previewImage: '/img/placeholder.png',
                user_address: '',
                description: '',
                added_product: 0,
                // isWorker: false,
                // isCustomer: false,
                // isVendor: false,

                is_worker: true,
                is_customer: false,
                is_vendor: false,

                details: [],
                items_jobs: [{row_id: '0', name: '', department: '', title: '', default: false, branch: ''}],
                permission_group_items: [],
                selected_permission_group: 0,
                marker: null,

                area_items: [],
                selected_area: 0,

                district_items: [],
                selected_district: 0,

                province_items: [],
                selected_province: 0,

                city_items: [],
                selected_city: 0,

                job_items: [],

                night_job: false,
                shift_job: false,
                extra_job: false,
                collapseDuration: 0,
                status_form: 0
            }
        },
        mounted() {
            this.$root.root_validate_errors = [];
            this.createMap();

            this.get_statuses();
            // this.get_jobs();
            this.get_branches();
            this.get_permission_groups();
            this.get_bank();
            this.get_sys();
            this.get_country();
            bus.$on('close_add_base_modal', (data) => {
                this.get_areas();
            });
            if (this.$route.params.user_id != null) {
                this.status_form = this.$route.params.user_id;
                this.get_user_data();
            }
        },
        computed: {
            get_department_jobs() {
                if (this.get_department_mates(this.selected_department, this.department_all_job_titles)) {


                    this.selected_job = this.get_department_mates(this.selected_department, this.department_all_job_titles)[0].value
                    return this.get_department_mates(this.selected_department, this.department_all_job_titles)
                }
            }
        },
        watch: {
            'postCode': function () {
                this.postCode = this.postCode.toUpperCase();
            },
            '$route.params.user_id': function () {
                this.status_form = this.$route.params.user_id;
                this.get_user_data();
                location.reload()
            },
            'selected_province': function () {
                this.get_cities();
            },
            'selected_city': function () {
                this.selected_district = 0;
                this.district_items = [];
                this.get_districts();
            },
            'selected_district': function () {
                this.get_areas();
            },
            'selected_branch': function () {
                this.get_departments();
            },
            'selected_department': function () {
                this.get_jobs();
            },
            'selected_country': function () {
                this.get_provinces();
            }
        },
        methods: {
            get_country() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetCountries', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.country_items = [];
                        self.country_items = self.sort_array(
                            self.country_items, content_data.data,
                            'id', 'title');


                        // self.province_items = content_data.data;
                        if (self.$i18n.locale == 'fa') {
                            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
                        }
                        if (self.$i18n.locale == 'en') {
                            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                }).catch(function (error) {

                    console.log(error);
                });

            },

            handleFileUpload(files, e) {
                try {
                    this.file = e.target.files[0];
                    var previewimg = URL.createObjectURL(this.file);
                    this.previewImage = previewimg;
                    e.target.value = '';
                    e.target.files = '';

                } catch (e) {
                    // console.log("",e)
                }
            },
            clear_input_file() {
                this.$refs.file_selector.$el.getElementsByTagName('input')[0].value = "";

            },
            open_file_selector() {
                this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()
            },
            jobs_defualt_checked(index) {
                // console.log("default clicked",index)
                for (var i = 0; i < this.items_jobs.length; i++) {
                    if (i == index) {
                        this.items_jobs[i].default = true;
                    } else {
                        this.items_jobs[i].default = false;

                    }
                }

            },
            get_bank() {
                var self = this;

                const formData = new FormData();

                axios.post('GetBanks', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.bank_items = [];
                        self.bank_items = self.sort_array(
                            self.bank_items, content_data.data,
                            'id', 'bankTitle');

                        self.selected_bank = self.bank_items[0].value
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_sys() {
                var self = this;

                const formData = new FormData();

                axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.prefx_options = [{label: self.$t('select'), value: 0}];
                    self.contact_options = [{label: self.$t('select'), value: 0}];
                    self.gender_options = [{label: self.$t('select'), value: 0}];
                    self.marital_options = [{label: self.$t('select'), value: 0}];
                    self.resident_options = [{label: self.$t('select'), value: 0}];
                    self.work_time_options = [{label: self.$t('select'), value: 0}];
                    self.shift_options = [{label: self.$t('select'), value: 0}];
                    self.payments_options = [{label: self.$t('select'), value: 0}];
                    self.payment_frequency = [{label: self.$t('select'), value: 0}];
                    self.person_types = [{label: self.$t('select'), value: 0}];
                    self.emergency_relationships = [{label: self.$t('select'), value: 0}];
                    self.emergency_educations = [{label: self.$t('select'), value: 0}];


                    content_data.forEach((val) => {
                        var obj = {label: val.title, value: val.id}

                        if (val.titleType == 1) {
                            self.prefx_options.push(obj);
                        }
                        if (val.titleType == 8) {
                            if (obj.label != "Email") {
                                self.contact_options.push(obj);

                            }
                        }
                        if (val.titleType == 2) {
                            self.gender_options.push(obj);
                        }
                        if (val.titleType == 3) {
                            self.marital_options.push(obj);
                        }
                        if (val.titleType == 4) {
                            self.resident_options.push(obj);
                        }
                        if (val.titleType == 5) {
                            self.work_time_options.push(obj);
                        }
                        if (val.titleType == 11) {
                            self.shift_options.push(obj);
                        }
                        if (val.titleType == 12) {
                            self.frequency_options.push(obj);
                        }
                        if (val.titleType == 29) {
                            self.payments_options.push(obj);
                        }
                        if (val.titleType == 14) {
                            self.person_types.push(obj);
                        }
                        if (val.titleType == 16) {
                            self.emergency_relationships.push(obj);
                        }
                        if (val.titleType == 17) {
                            self.emergency_educations.push(obj);
                        }
                    });
                    self.MaritalStatus = self.marital_options[0].value

                    self.title = self.prefx_options[0].value
                    self.gender = self.gender_options[0].value
                    self.residentStatus = self.resident_options[0].value
                    self.comperation_type = self.work_time_options[0].value
                    self.payment_frequency = self.frequency_options[0].value
                    self.payment_method = self.payments_options[0].value
                    self.shift = self.shift_options[0].value
                    self.person_type = self.person_types[0].value
                    self.emergency_relationship = self.emergency_relationships[0].value
                    self.emergency_education = self.emergency_educations[0].value


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            add_job_item() {
                console.log(this.job_items, this.selected_job)
                var item = {
                    name: '',
                    department: this.department_items.find(z => z.value === this.selected_department).label,
                    department_id: this.selected_department,
                    title: this.job_items.find(z => z.value === this.selected_job).label,
                    title_id: this.selected_job,
                    default: false,
                    branch: this.branch_items.find(z => z.value === this.selected_branch).label,
                    branch_id: this.selected_branch,
                }
                if (this.items_jobs.length == 1) {
                    item.default = true;
                }
                this.items_jobs.push(item)
            },
            job_item_edit(item, index) {
                // var item = [];
// this.items[0] = item;
                console.log("edit item");
                Vue.set(this.items_jobs, 0, item)
            },
            job_item_delete(index) {
                this.items_jobs.splice(index, 1);
            },
            get_departments() {
                var self = this;

                const formData = new FormData();

                formData.append('BranchId', this.selected_branch);


                axios.post('BranchDeparteman/GetData', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.department_items = []

                        self.department_all_job_titles = response.data.data.filter(x => x.branchId == self.selected_branch);
                        // var departments = response.data.data;
                        // departments = departments.filter(item => item.recType == 0);
                        var departments = response.data.data.filter(x => x.branchId == self.selected_branch);

                        departments.forEach((val) => {
                            // if (val.parentId == 0) {

                            var obj = {
                                "label": val.mainDepartemanTitle,

                                parentId: val.parentId,
                                value: val.mainDepartemanId,
                                recType: val.recType,
                                image_url: '/img/avatars/custom.png',

                                // "selected":true,
                                children: self.get_department_childrens(val.id, response.data.data),
                                // mate: self.get_mates(val.id, response.data.data)
                            }
                            self.department_items.push(obj);
                            // }

                        });
                        self.selected_department = self.department_items[0].value
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            get_department_childrens(parent_id, list) {
                var array = [];
                list.forEach((val2) => {

                    if (parent_id == val2.parentId && val2.recType == 0) {
                        var obj = {
                            name: val2.title,
                            id: val2.id,
                            children: this.get_department_childrens(val2.id, list),
                            // mate: this.get_mates(val2.id, list),
                            recType: val2.recType,

                            parentId: val2.parentId,
                            image_url: '/img/avatars/custom.png',

                        }
                        array.push(obj);

                        // val2.inserted = true;

                    }

                });
                if (array.length) {
                    return array;

                } else {
                    return null;

                }

            },
            get_department_mates(parent_id, list) {
                var array = [];
                list.forEach((val2) => {

                    if (parent_id == val2.parentId && val2.recType == 1) {
                        var obj = {
                            label: val2.title,
                            value: val2.id,
                            children: this.get_department_childrens(val2.id, list),
                            mate: this.get_department_mates(val2.id, list),
                            parentId: val2.parentId,
                            image_url: '/img/avatars/custom.png',

                        }
                        array.push(obj);
                        // val2.inserted = true;

                    }
                });

                if (array.length) {
                    return array;

                } else {
                    return null;

                }
            },
            get_branches() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetBranchList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.branch_items = [];
                        self.branch_items = self.sort_array(
                            self.branch_items, content_data.data,
                            'branchId', 'branchTitle');

                        self.selected_branch = self.branch_items[0].value

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_statuses() {
                var self = this;

                const formData = new FormData();

                axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.status_items = [];
                    // GetProductStatusList
                    content_data.forEach((val) => {
                        var obj = {label: val.title, value: val.id}

                        if (val.titleType == 15) {
                            self.status_items.push(obj);
                        }

                    });


                    self.selected_status = self.status_items[0].value

                })
                    .catch(function (error) {

                        console.log(error);
                    });
            },
            add_phone_obj() {
                console.log('add clicked')

                this.phone_objects.push({row_id: 19, phone_type: 19, phone: ''})
                var row_index = 1;
                this.phone_objects.forEach((val) => {
                    val.row_id = row_index;
                    row_index += 1;

                });


                var copy = this.phone_objects;
                this.phone_objects = [];
                this.phone_objects = copy;

            },
            remove_phone_obj(index) {
                console.log('remove clicked')
                if (this.phone_objects.length > 1) {
                    this.phone_objects.splice(index - 1, 1);
                    var row_index = 1;
                    this.phone_objects.forEach((val) => {
                        val.row_id = row_index;
                        row_index += 1;
                    });

                    var copy = this.phone_objects;
                    this.phone_objects = [];
                    this.phone_objects = copy;

                }
            },
            add_email_obj() {
                console.log('add clicked')

                this.email_objects.push({row_id: 18, phone_type: 0, phone: ''})
                var row_index = 1;
                this.email_objects.forEach((val) => {
                    val.row_id = row_index;
                    row_index += 1;

                });


                var copy = this.phone_objects;
                this.phone_objects = [];
                this.phone_objects = copy;

            },
            remove_email_obj(index) {
                console.log('remove clicked', index)
                if (this.email_objects.length > 1) {
                    this.email_objects.splice(index - 1, 1);
                    var row_index = 1;
                    this.email_objects.forEach((val) => {
                        val.row_id = row_index;
                        row_index += 1;

                    });

                    var copy = this.phone_objects;
                    this.phone_objects = [];
                    this.phone_objects = copy;

                }
            },
            validateForm: function () {
                this.$root.root_validate_errors = [];


                if (this.name != '' && this.user_address != '' && this.phone_objects[0].phone.length == 11 && this.items_jobs.length > 1) {
                    return true;

                }

                if (this.name == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
                }

                if (this.items_jobs.length <= 1) {
                    this.$root.root_validate_errors.push(this.$t('silectOneJobUnit'));
                }


                if (this.user_address == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.insertAddress'));
                }
                if (this.phone_objects[0].phone.length != 1) {
                    this.$root.root_validate_errors.push(this.$t('insertCorrectMobile'));

                }


                return false;
                // e.preventDefault();
            },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            createMap() {
                var self = this;
                // init the map
                mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg';
                if (mapboxgl.getRTLTextPluginStatus() == "unavailable") {
                    mapboxgl.setRTLTextPlugin(
                        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
                        null,
                        true // Lazy load the plugin
                    );
                }

                var center_loc = [51.37734351262877, 35.697451890638886];
                if (self.$i18n.locale == 'en') {
                    center_loc = [-0.03880407284764019, 51.573360744046745];
                }
                self.map = new mapboxgl.Map({
                    container: 'map',
                    style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
                    center: center_loc,
                    zoom: 14 // starting zoom
                });

                self.polygon_draw = new MapboxDraw({
                    displayControlsDefault: false,
                    controls: {
                        polygon: true,
                        trash: true
                    }
                });
                // self.map.addControl(self.polygon_draw);
                // self.map.on('draw.create', self.updatePolygonArea);
                // self.map.on('draw.delete', self.updatePolygonArea);
                // self.map.on('draw.update', self.updatePolygonArea);

                // self.map.addControl(new mapboxgl.Navigation())
                self.map.on('click', function (e) {
                    if (self.marker != null) {
                        self.marker.remove();
                    }
                    // if (self.user_location_lat == 0) {

                    self.marker = new mapboxgl.Marker({
                        draggable: true
                    })

                        .setLngLat(e.lngLat)
                        .addTo(self.map);
                    self.user_location_lat = e.lngLat.lat;
                    self.user_location_lng = e.lngLat.lng;

                    // }

                    function onDragEnd() {
                        // var lngLat = marker.getLngLat();
                        self.user_location_lat = self.marker.getLngLat().lat;
                        self.user_location_lng = self.marker.getLngLat().lng;

                    }

                    function onDragStart() {
                        // var lngLat = marker.getLngLat();
                        console.log("drag started");
                        self.user_location_lat = self.marker.getLngLat().lat;
                        self.user_location_lng = self.marker.getLngLat().lng;

                    }

                    self.marker.on('dragend', onDragEnd);
                    self.marker.on('dragstart', onDragStart);
                    console.log('A click event has occurred at ' + e.lngLat);
                    // }

                });

                self.map.on('load', function () {
                    self.show_polygon();
                });
            },
            updatePolygonArea() {
                var data = this.polygon_draw.getAll();
                // console.log(data);
                if (data.features.length > 0) {
                    this.polygon_area = data.features[0].geometry.coordinates;
                    this.show_polygon();

                } else {
                    this.polygon_area = [];
                    this.show_polygon();

                }
            },
            show_polygon() {

                this.map.addSource('maine', {
                    'type': 'geojson',
                    'data': {
                        'type': 'Feature',
                        'geometry': {
                            'type': 'Polygon',
                            'coordinates': this.polygon_area

                        }
                    }
                });
                this.map.addLayer({
                    'id': 'maine',
                    'type': 'fill',
                    'source': 'maine',
                    'layout': {},
                    'paint': {
                        'fill-color': '#088',
                        'fill-opacity': 0.8
                    }
                });


            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = this.items[item.row_id].unitName;
                this.color = this.items[item.row_id].color;
                this.description = this.items[item.row_id].description;
                this.previewImage = this.items[item.row_id].image;
                this.status_form = this.items[item.row_id].id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                if (this.status_form != 0) {
                    this.$router.push({path: '/dashboard/products/list'})
                } else {
                    this.status_form = 0;
                    this.name = '';
                    this.color = '';
                    this.description = '';
                    this.previewImage = '';
                    this.weight = '';
                    this.selected_unit = '0';
                    this.selected_brand = '0';
                    this.selected_category = '0';
                    this.barcode = '';
                }

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },


            get_permission_groups() {
                var self = this;
                const formData = new FormData();

                // formData.append('id', this.selected_province);

                axios.post('GetUserGroupTitles', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.permission_group_items = [];

                        var obj = {label: self.$t('components.userRole'), value: 0}
                        self.permission_group_items.push(obj);

                        content_data.data.forEach((val) => {
                            var obj = {label: val.groupName, value: val.id}

                            self.permission_group_items.push(obj);
                        });

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_districts() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_city);

                axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                        self.district_items = []
                        self.district_items = self.sort_array(
                            self.district_items, content_data.data,
                            'id', 'title');
                        if (self.selected_district == 0) {
                            self.selected_district = self.district_items[0].value;
                        }

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }

                }).catch(function (error) {

                    console.log(error);
                });
            },
            get_provinces() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_country);


                axios.post('GetStateList', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.province_items = [];
                        self.province_items.push({label: self.$t('dialogs.insertProvince'), value: 0});
                        self.province_items = self.sort_array(self.province_items, content_data.data, 'id', 'provinceName')
                        // content_data.data.forEach((val) => {
                        //   self.province_items.push({label: val.provinceName, value: val.id});
                        // });
// self.selected_province = self.province_items[0].value;
                        // self.province_items = content_data.data;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cities() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);

                axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

                    var content_data = response.data;
                    self.city_items = [];
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        var obj = {label: self.$t('dialogs.insertCity'), value: 0}
                        self.city_items.push(obj);
                        self.city_items = self.sort_array(
                            self.city_items, content_data.data,
                            'cityId', 'cityName');


                        // self.city_items = content_data.data;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            get_areas() {
                var self = this;
                const formData = new FormData();

                formData.append('id', this.selected_district);

                axios.post('GetAreaTitlesByCityId', formData, {show_pros: true}).then(function (response) {
                    self.area_items = [];
                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var obj = {label: self.$t('dialogs.insertArea'), value: 0}
                        self.area_items.push(obj);
                        self.area_items = self.sort_array(
                            self.area_items, content_data.data,
                            'id', 'areaName');


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            go_to_add_modal(func) {
                bus.$emit("show_add_base_modal", func);
            },
            get_user_data() {

                let self = this;
                const formData = new FormData();
                let url;
                url = "GetPersonById";

                formData.append('id', this.status_form);


                axios.post(url, formData, {}).then((res) => {

                    var person_data = res.data.data.person;
                    self.name = person_data.personName;
                    self.previewImage = this.$root.base_url + "/" + person_data.imageName;
                    if (self.previewImage == "" || self.previewImage == null) {
                        self.previewImage = '/img/placeholder.png';
                    }
                    self.edit_name = person_data.personName;
                    self.edit_last_name = person_data.surName;
                    self.edit_user_code = person_data.personCode;

                    self.title = person_data.title;
                    self.tablo_name = person_data.personTitle;
                    self.meli_code = person_data.nationalCode;
                    self.mobile = person_data.mobileNo;
                    self.phone_no = person_data.phoneNo;
                    self.is_worker = person_data.isWorker;
                    self.is_customer = person_data.isCustomer;
                    self.is_vendor = person_data.isVendor;


                    self.porsant = person_data.porsant;
                    self.password = person_data.pass;
                    self.selected_permission_group = person_data.groupId;

                    self.middle_name = person_data.middelName;
                    self.sur_name = person_data.surName;
                    if (person_data.image != "") {
                        self.previewImage = person_data.image
                    }
//**********************************************
                    var person_address = res.data.data.personAddress[0];

                    if (person_address != null) {
                        self.selected_country = person_address.countryId;
                        self.selected_province = person_address.provinceId;
                        self.selected_city = person_address.cityId;
                        self.selected_district = person_address.regionId;
                        self.selected_area = person_address.areaRelId;
                        self.user_address = person_address.addressText;
                        self.user_location_lat = person_address.lat;
                        self.user_location_lng = person_address.lng;
                        self.postCode = person_address.postCode;
                    }
//**********************************************


                    self.selected_status = person_data.personStatus
//contacts contact
                    self.phone_objects = [];
                    self.email_objects = [];
                    res.data.data.personContacts.forEach((val) => {
                        if (val.contactType == 18) {
                            self.email_objects.push({phone_type: val.contactType, phone: val.contact});
                        } else {
                            self.phone_objects.push({phone_type: val.contactType, phone: val.contact});

                        }
                    });

                    if (!self.email_objects.length) {
                        self.email_objects = [{phone_type: 18, phone: '', row_id: 1}];
                    }
                    if (!self.phone_objects.length) {
                        self.phone_objects = [{phone_type: 19, phone: '', row_id: 1}];
                    }
                    //departments
                    var person_departments = res.data.data.userDepartemans;
                    self.items_jobs = [{}]
                    person_departments.forEach((val) => {
                        self.items_jobs.push({
                            branch_id: val.branchId,
                            department_id: val.departemanId,
                            title_id: val.positionId,
                            default: val.isDefault,
                            branch: val.branchTitle,
                            department: val.departemanTitle,
                            title: val.positionTitle
                        })

                    });

//emergency contact

                    var person_emergency = res.data.data.personEmrgencyContact;
                    if (person_emergency) {
                        self.emergency_name = person_emergency.name;
                        self.emergency_surname = person_emergency.surName;
                        self.emergency_relationship = parseInt(person_emergency.relationship);
                        self.emergency_mobile = person_emergency.mobile;

                        self.emergency_training = person_emergency.trainingCourses;
                        self.emergency_disability = person_emergency.disabilityStatus;
                    }

//Bank Info

                    var person_bank = res.data.data.personBankInfo;
                    if (person_bank) {

                        self.selected_bank = person_bank.bankId;
                        self.account_name = person_bank.accountName;
                        self.account_no = person_bank.accountNo;
                        self.sort_code = person_bank.sortCode;
                        self.ibna = person_bank.iban;
                    }
//other Info
                    var person_extra = res.data.data.personExtraInfo;
                    if (person_extra) {

                        self.gender = person_extra.gender;
                        self.birth_date = person_extra.birthData;
                        self.bime_number = person_extra.bimeNumber;
                        self.MaritalStatus = person_extra.maritalStatus;
                        self.residentStatus = person_extra.residentialStatus;
                        self.nationality = person_extra.citizenship;
                        self.meli_code = person_extra.nationalCode;
                        self.person_type = person_extra.personTypeId;
                        self.emergency_language = person_extra.otherLanguage;
                        self.emergency_education = parseInt(person_extra.education);
                        self.emergency_skills = person_extra.skills;
                    }
//job Profile

                    var person_job = res.data.data.personJobProfile;
                    if (person_job) {

                        self.employee_date = person_job.employmentDate;
                        self.contract_number = person_job.contractNumber;
                        self.comperation_type = person_job.cooperationType;
                        self.leave_date = person_job.leaversDate;
                        self.reson_for_leave = person_job.reasonsForLeaving;
                        self.benefit = person_job.benefit;
                        self.pension_date = person_job.pensionStartDate;
                        self.wage = person_job.wage;
                        self.shift = parseInt(person_job.shift);
                        self.hours = person_job.hours;
                        self.payment_frequency = person_job.paymentFrequency;
                        self.payment_method = person_job.paymentMethod;
                        self.extra_job = person_job.extrajob;
                        self.night_job = person_job.nightJob;
                        self.shift_job = person_job.shiftJob;
                    }
                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
            get_jobs() {
                var self = this;
                // console.log("route id " + this.$route.params.cat_id);

                const formData = new FormData();


                formData.append('RecType', 1);
                formData.append('ParentId', this.selected_department);

                axios.post('Departeman/Getdata', formData, {}).then(function (response) {


                    // axios.post('MainDeparteman/GetData', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        var jobs = content_data.data;
                        console.log(self.selected_department)
                        self.job_items = [];
                        // jobs = jobs.filter(item => item.recType == 1);
                        jobs = jobs.filter(item => item.parentId == self.selected_department);

                        self.job_items = self.sort_array(
                            self.job_items, jobs,
                            'jobId', 'jobTitle');

                        // jobs.forEach((val) => {
                        //   var obj = {label: val.jobTitle, value: val.jobId}
                        //
                        //   self.job_items.push(obj);
                        // });
                        if (self.job_items.length)
                            self.selected_job = self.job_items[0].value
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            insert_data() {
                if (!this.validateForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }

                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddPerson";
                } else {
                    url = "EditPerson";
                    formData.append('PersonId', this.status_form)

                }
                var person = {
                    // this.tablo_name
                    'Title': this.title,
                    'PersonId': this.status_form,
                    'MiddelName': this.middle_name,
                    'SurName': this.sur_name,
                    'PersonTitle': '',
                    'PersonName': this.name,
                    'PersonCode': '',
                    'NationalCode': this.meli_code,
                    'MobileNo': '',
                    'PhoneNo': '',
                    'IsWorker': true,
                    'IsCustomer': this.is_customer,
                    'IsVendor': this.is_vendor,
                    'GuildUnitTitleId': 0,

                    'Porsant': this.porsant,
                    'PStatus': this.selected_status,
                }
                var person_address = [{
                    // this.tablo_name

                    'CountryId': this.selected_country,
                    'ProvinceId': this.selected_province,
                    'CityId': this.selected_city,
                    'RegionId': this.selected_district,
                    'postCode': this.postCode,

                    'AreaRelId': this.selected_area,
                    'AddressText': this.user_address,
                    'Lat': this.user_location_lat,
                    'Lng': this.user_location_lng,

                }]
                var PeopleInfos = []

                var UserDeparteman = []
                if (this.items_jobs.length > 0) {
                    for (var i = 1; i < this.items_jobs.length; i++) {
                        console.log(this.items_jobs[i])
                        UserDeparteman.push({
                            'BranchId': this.items_jobs[i].branch_id,
                            'DepartemanId': this.items_jobs[i].department_id,
                            'PositionId': this.items_jobs[i].title_id,
                            'IsDefault': this.items_jobs[i].default,
                        });
                    }
                }
                var PersonContact = []
                if (this.phone_objects.length > 0) {
                    for (i = 0; i < this.phone_objects.length; i++) {
                        PersonContact.push({
                            'ContactType': this.phone_objects[i].phone_type,
                            'Contact': this.phone_objects[i].phone,
                        });
                    }
                }
                if (this.email_objects.length > 0) {
                    for (i = 0; i < this.email_objects.length; i++) {
                        PersonContact.push({
                            'ContactType': 18,
                            'Contact': this.email_objects[i].phone,
                        });
                    }
                }
                var PersonExtraInfo = {
                    "Gender": this.gender,
                    "PersonTypeId": this.person_type,
                    "BirthData": this.birth_date,
                    "BimeNumber": this.bime_number,
                    "MaritalStatus": this.MaritalStatus,
                    "Citizenship": this.nationality,
                    "OtherLanguage": this.emergency_language,
                    "Education": this.emergency_education,
                    "Skills": this.emergency_skills,

                    "ResidentialStatus": this.residentStatus,
                    "NationalCode": this.meli_code,
                }
                var PersonBankInfo = {
                    "BankId": this.selected_bank,
                    "AccountName": this.account_name,
                    "AccountNo": this.account_no,
                    "SortCode": this.sort_code,
                    "Iban": this.ibna,
                }
                var PersonEmrgencyContact =
                    {
                        "Name": this.emergency_name,
                        "SurName": this.emergency_surname,
                        "Relationship": this.emergency_relationship,
                        "Mobile": this.emergency_mobile,
                        "OtherLanguage": this.emergency_language,
                        "Education": this.emergency_education,
                        "Skills": this.emergency_skills,
                        "TrainingCourses": this.emergency_training,
                        "DisabilityStatus": this.emergency_disability,
                    }

                var PersonJobProfile = {
                    'EmploymentDate': this.employee_date,
                    'ContractNumber': this.contract_number,
                    'CooperationType': this.comperation_type,
                    'LeaversDate': this.leave_date,
                    'ReasonsForLeaving': this.reson_for_leave,
                    'Benefit': this.benefit,
                    'PensionStartDate': this.pension_date,
                    'wage': this.wage,
                    'shift': this.shift,
                    'hours': this.hours,
                    Extrajob: this.extra_job,
                    NightJob: this.night_job,
                    ShiftJob: this.shift_job,
                    'paymentFrequency': this.payment_frequency,
                    'paymentMethod': this.payment_method,
                    SaleType: 0,

                }

                var UserGroup = {
                    GroupRecId: this.selected_permission_group,
                }
                var PersonModule = {
                    "Person": person,
                    "PersonContacts": PersonContact,
                    "UserDepartemans": UserDeparteman,
                    "PersonExtraInfo": PersonExtraInfo,
                    "PersonBankInfo": PersonBankInfo,
                    "PersonEmrgencyContact": PersonEmrgencyContact,
                    "PersonJobProfile": PersonJobProfile,
                    "UserGroup": UserGroup,
                    "PersonAddress": person_address,
                    "PeopleInfos": PeopleInfos,

                }
                formData.append('PersonModule', JSON.stringify(PersonModule));
                formData.append('File', this.file);
                // formData.append('PersonCode', "");
                // formData.append('Image', this.file);

                // formData.append('AddressText', this.address);
                // formData.append('Pass', this.password);
                // formData.append('Porsant', this.porsant);
                // formData.append('GroupId', this.selected_permission_group);
                // formData.append('Lat', this.user_location_lat);
                // formData.append('Lng', this.user_location_lng);
                // formData.append('Color', this.color);
                // formData.append('description', this.description);
                axios.post(url, formData, {}).then((res) => {


                    // self.get_lists();
                    self.$root.modal_component.show_api_response_modals(res);
                    if (res.data.statusCode == 0) {
                        if (self.status_form == 0) {
                            self.$router.push({path: '/dashboard/users/edit-user/' + res.data.data.id})
                            // window.location.reload()
                        }

                    } else {

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
        }
    }

</script>
